import React from "react";
import {
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import { compose, withProps, withHandlers } from "recompose";
import invariant from "invariant";
import { get, pick } from "lodash";
import { NotificationManager } from "react-notifications";

const propPick = [
  "Contact",
  "CurrencyCode",
  "Date",
  "DueDate",
  "LineAmountTypes",
  "LineItems",
  "Reference",
  "Type",
  "DocumentType",
];


export function get_view_url(item) {
  let type = ""
  if (item.Type)
    type = item.Type
  else if (item.QuoteID){
    type = "QUOATE"
  }else if (item.ManualJournalID){
    type = "MANUAL_JOURNAL"
  }
  const urls_view_map = {
    "PURCHASEORDER": `https://go.xero.com/Accounts/Payable/PurchaseOrders/Edit/${item.PurchaseOrderID}/`,
    "ACCPAYCREDIT": `https://go.xero.com/AccountsPayable/EditCreditNote.aspx?creditNoteID=${item.CreditNoteID}`,
    "ACCRECCREDIT": `https://go.xero.com/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${item.CreditNoteID}`,
    "ACCPAY": `https://go.xero.com/AccountsPayable/View.aspx?InvoiceID=${item.InvoiceID}`,
    "ACCREC": `https://go.xero.com/app/invoicing/view/${item.InvoiceID}`,
    "QUOATE": `https://go.xero.com/app/!844SS/quotes/edit/${item.QuoteID}`,
    "MANUAL_JOURNAL": `https://go.xero.com/Journal/View.aspx?invoiceID=${item.ManualJournalID}`,
  }
  return urls_view_map[type]
}

const poPick = [
  ...propPick,
  "DeliveryInstructions",
  "Telephone",
  "AttentionTo",
  "DeliveryAddress",
];

const OptionsView = ({
  title,
  isCreditNote,
  isInvoice,
  isPurchaseOrder,
  isBill,
  isPrepayment,
  item,
  match,
  handleDelete,
  handleVoid,
  handleCopy,
  handleAddCreditNote,
  newUrl = match.url.replace("/view/", "/edit/"),
  idKey,
}) => {
  return (
  <UncontrolledButtonDropdown>
    <DropdownToggle caret color="primary" className="btn-sm">
      <Trans>{title}</Trans>
    </DropdownToggle>
    <DropdownMenu className="clickable p-0">
      {(isCreditNote || isPrepayment) && item.Status === "AUTHORISED"  && (
        <Link className="dropdown-item" to={`${newUrl}/allocate`}>
          <Trans>Allocate Credit</Trans>
        </Link>
      )}
      {(isInvoice || isBill) && item.Status === "AUTHORISED" && (
        <DropdownItem onClick={handleAddCreditNote} className="clickable">
          <Trans>Add Credit Note</Trans>
        </DropdownItem>
      )}
      {!isPrepayment && <DropdownItem onClick={handleCopy} className="clickable">Make A Copy</DropdownItem>}
      {!isPrepayment && 
      <DropdownItem>
        <a className="link" href={get_view_url(item) || "#"} target="_blank">
          <Trans>View in Xero</Trans>
        </a>
      </DropdownItem>
      }
      {(isPurchaseOrder ||
        item.Status === "DRAFT" ||
        item.Status === "SUBMITTED") &&
        item[idKey] && (
          <DropdownItem onClick={handleDelete} className="text-danger clickable">
            Delete
          </DropdownItem>
        )}
      {((isCreditNote && item.Type !== "ACCRECCREDIT") || isBill) &&
      item.Status === "AUTHORISED" &&
      !get(item, "Payments.length") ? (
        <DropdownItem className="text-danger clickable" onClick={handleVoid}>
          Void
        </DropdownItem>
      ) : null}
    </DropdownMenu>
  </UncontrolledButtonDropdown>
  )
}

const enhance = compose(
  withProps(({ isInvoice, isCreditNote, isPurchaseOrder, isBill, isPrepayment }) => {
    let title = "Options";
    let idKey = null;
    let manager = null;

    if (isInvoice) {
      idKey = "InvoiceID";
      manager = "invoices";
    } else if (isCreditNote) {
      idKey = "CreditNoteID";
      manager = "creditnotes";
    } else if (isBill) {
      idKey = "InvoiceID";
      manager = "invoices";
    } else if (isPurchaseOrder) {
      idKey = "PurchaseOrderID";
      manager = "purchaseorders";
    }else if (isPrepayment) {
      idKey = "PrepaymentID";
      manager = "prepayments";
    } else {
      invariant(false, "isInvoice or isCreditNote must be set");
    }

    return {
      title,
      idKey,
      manager,
    };
  }),
  withHandlers({
    handleDelete:
      ({ manager, item, idKey, xero, t, history, setXeroErrors, match }) =>
      () => {
        xero
          .patch(`${manager}/${item[idKey]}`, {
            [idKey]: item[idKey],
            Status: "DELETED",
          })
          .then(() => {
            NotificationManager.success(t("Deleted successfully"));
            history.replaceUp();
          }, setXeroErrors);
      },
    handleAddCreditNote:
      ({ isBill, history, item }) =>
      () => {
        const percentageRemaining =
          1 - Number(item.AmountPaid) / Number(item.Total);

        history.push(
          `/${
            isBill ? "purchases" : "accounts_receivable"
          }/credit_notes/edit/new`,
          {
            copy: {
              ...pick(item, [
                "Contact",
                "LineAmountTypes",
                "CurrencyCode",
                "Date",
              ]),
              LineItems: item.LineItems.map((i) => ({
                ...i,
                UnitAmount:
                  (Number(i.LineAmount) / Number(i.Quantity)) *
                  percentageRemaining,
                DiscountRate: 0,
              })),
              Status: "DRAFT",
              Type: isBill ? "ACCPAYCREDIT" : "ACCRECCREDIT",
              RemainingCredit: 0,
              Allocations: [
                {
                  IsNew: true,
                  Invoice: {
                    InvoiceID: item.InvoiceID,
                    InvoiceNumber: item.HesaabNumber || item.InvoiceNumber,
                  },
                  Amount: item.AmountDue,
                },
              ],
            },
          }
        );
      },
    handleCopy:
      ({ item, history, reload }) =>
      () => {
        const pathInv = "/accounts_receivable/invoices"
        const pathBill = "/purchases/bills"
        const pathPO = "/purchases/purchase_orders"
        const pathCdInv = "/accounts_receivable/credit_notes"
        const pathCdBill = "/purchases/credit_notes"
        const whichPick = item.Type === "PURCHASEORDER" ? poPick : propPick
        const route =
          item.Type === "ACCREC" ? pathInv :
          item.Type === "ACCPAY" ? pathBill :
          item.Type === "PURCHASEORDER" ? pathPO :
          item.Type === "ACCRECCREDIT" ? pathCdInv :
          item.Type === "ACCPAYCREDIT" ? pathCdBill :
          "new";
        history.push(route + "/edit/new", {
          copy: {
            ...pick(item, whichPick),
            Status: "DRAFT",
          },
        });
        reload();
      },
    handleVoid:
      ({ manager, item, idKey, xero, t, history, setXeroErrors, match }) =>
      () => {
        xero
          .patch(`${manager}/${item[idKey]}`, {
            [idKey]: item[idKey],
            Status: "VOIDED",
          })
          .then(() => {
            NotificationManager.success(t("Voided successfully"));
            history.replaceUp();
          }, setXeroErrors);
      },
  })
);

const Options = enhance(OptionsView);

export const withOptions = () => (BaseComponent) =>
  class extends React.Component {
    renderCreditNoteOptions = (props) => {
      return <Options {...this.props} {...props} isCreditNote />
    }
    ;
    renderInvoiceOptions = (props) => (
      <Options {...this.props} {...props} isInvoice />
    );
    renderBillOptions = (props) => (
      <Options {...this.props} {...props} isBill />
    );
    renderPurchaseOrderOptions = (props) => (
      <Options {...this.props} {...props} isPurchaseOrder />
    );
    renderPrepaymentOptions = (props) => (
      <Options {...this.props} {...props} isPrepayment />
    );
    render = () => (
      <BaseComponent
        {...this.props}
        BillOptions={this.renderBillOptions}
        InvoiceOptions={this.renderInvoiceOptions}
        PurchaseOrderOptions={this.renderPurchaseOrderOptions}
        CreditNoteOptions={this.renderCreditNoteOptions}
        PrePaymentOptions={this.renderPrepaymentOptions}
      />
    );
  };

export default withOptions;
